<template>
<div class="VstudentTitleCard">
   <!-- v-if="studentList.length>0" -->
 <div class="center">
      <div v-if="isStatus" class="isStatusClass">
          <img v-if="+studentInfo.status==0" src="@/assets/image/待审核.png" alt="" width="100">
          <img v-if="+studentInfo.status==1" src="@/assets/image/已审核.png" alt=""  width="100">
          <img v-if="+studentInfo.status==2" src="@/assets/image/审核不通过.png" alt=""  width="100">
      </div>

        <van-row  gutter="16" class="infobox">
          <van-col span="5" @click="showUserDialog =true">
            
          <van-image style="border: 2px solid #fff;" round v-if="studentInfo&&studentInfo.sex=='男'" width="100%"  :src="require('@/assets/image/男生头像正.png')" rel="external nofollow" />
          <van-image style="border: 2px solid #fff;" round v-if="studentInfo&&studentInfo.sex=='女'" width="100%"  :src="require('@/assets/image/女生头像正.png')" rel="external nofollow" />
          <van-image style="border: 2px solid #fff;" round v-if="!studentInfo.sex" width="100%"  :src="require('@/assets/image/男生头像正.png')" rel="external nofollow" />
        </van-col>
        <van-col span="13" class="text_l">
          <div class="studentName">{{studentInfo.studentName||''}}</div>
          <div class="schoolName">{{studentInfo.schoolName||''}}</div>
          <div class="className">{{studentInfo.studentGradeName||''}}  {{studentInfo.adminClassName||''}}</div>
        </van-col>
        <van-col span="6" class="text_r">
          <div>
          <van-popover v-model="showPopover"  trigger="click" :actions="studentList" @select="onSelectPopover">
            <template #reference>
              <div  v-if="isChange">
              <van-icon name="exchange" class="onchangeClass"/>
              <span style="font-size:3.5vw;">切换</span>
              </div>
            </template>
          </van-popover>
          </div>
        </van-col>
        </van-row>
    <slot name="btn"/>

        
    </div>
    <van-popup v-model:show="showQRDialog" width="80%"  get-container="body" >
  <div >
  <vue-qr style="margin: 0 atuo;" :text="studentInfo.snCode+'&&'+studentInfo.schoolCode" :logoSrc="require('@/assets/background/loginLog.jpg')"   :margin='8'></vue-qr>
  </div>
</van-popup>
</div>
</template>
<script>
import { getChildInfoBySnCode} from "@/api/common.js";
import vueQr from 'vue-qr'
import { getChildInfoList} from "@/api/studentBind.js";
 import { setSession ,getSession} from "@/utils/cookie";

export default {
  name: 'VstudentTitleCard',
  components: {vueQr},
  props: {
  // 文本
    icon: {
      type: String,
      default: '',
    },
    
    // snCode: {
    //   type: String,
    //   default: "",
    // },
     schoolCode: {
      type: String,
      default: "",
    },
    // 当已有学生信息的时候可以选择传入学生信息
    propsStudentInfo: {
      type: Object,
      default: ()=>{},
    },
    // 是否显示审核状态
    isStatus:{
      type: Boolean,
      default: false,
    },
    // 是否显示切换按钮
    isChange:{
      type: Boolean,
      default: false,
    },
    
    
  },

  watch:{
    snCode:{
          immediate: true,
      handler: async function(val) {
        console.log(val);
            if (val&&val!=='') {
            console.log(val);
                // this.getChildInfoBySnCode()
            }
    }
        
    },
    propsStudentInfo:{
          immediate: true,
      handler: async function(val) {
        console.log(val);
            if (val&&val!==''&&!this.snCode&&this.snCode=='') {
            console.log(val);
            this.studentInfo =val
            }
      }
    },
    studentInfo:{
          immediate: true,
      handler: async function(val) {
            if (val&&val.snCode&&val.snCode!=='') {
        this.$emit('change',val)
            }
      }
    },
  },
  data() {
    return {
        showQRDialog:false,
        studentInfo:{
            snCode:''
        },
        studentList:[],
        showPopover:false
    }
  },

  created() {

  },
  mounted () {
    this.getChildInfoList()
  },
  methods: {
    onSelectPopover(action){
      console.log(action);
    this.studentInfo = action
    setSession('studentTitleCard',JSON.stringify(this.studentInfo))
    this.$emit('change',action)
    },
        getChildInfoList(){
getChildInfoList({
  status:'-1'
}).then(res=>{
  if (res.data.data.length==0) {
              this.$dialog
                .alert({
                  width:'80%',
                title:'提示',
                message: '暂未绑定孩子信息，请先绑定！',
                showCancelButton: false
                }).then(() => {
    this.$router.push({path:'guidePage'})
                })
                  return
  }
    res.data.data?.forEach(el=>{
      this.$set(el,'text', el.studentName)
  })
  this.studentList = res.data.data||[]
  this.studentInfo = this.studentList[0]||{}

  if (getSession('studentTitleCard')) {
   this.studentInfo =  JSON.parse(getSession('studentTitleCard'))
  }else{
  setSession('studentTitleCard',JSON.stringify(this.studentInfo))
  }

  
})
    },
      onshowQr(item){
      console.log(1);
      this.showQRDialog =true
    },
    getChildInfoBySnCode(){
getChildInfoBySnCode({
    snCode:this.snCode,
    schoolCode:this.schoolCode,
}).then(res=>{
console.log(res);
this.studentInfo =res.data.body
})
    },
   buttonCustomClick() {
    this.$emit("click");
  }
  },
}
</script>

<style lang="less" scoped>
  .VstudentTitleCard {
    .center{
        // height: 290px;
        min-height: 14vh;
        padding:2vw;
        padding-top: 0;
        padding-bottom: 0;
        position: relative;
        // background-color: #216DD9;
        color: #fff;
        border-radius: 10px;
        margin:0 8px;
        // box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        .studentName{
          font-size: 4.8vw;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .schoolName{
          font-size: 3vw;
          margin: 5px 0 2px 0;
        }
        .className{
          font-size: 3vw;

        }
        .isStatusClass{
          position: absolute;
          right: 30px;
          top: 10px;
          // transform: rotate(45deg);
        }
        .onchangeClass{
          font-size: 4vw;
          font-weight: 600;
          // margin-left: 10px;
        }
        .center_value{
            color: #bbb;
        }
      
    }
    .text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;

    
}
.text_c{
    text-align: center;
}
  }


</style>
